var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialContext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5C12.1518 5 9 8.15178 9 12C9 15.8482 12.1518 19 16 19C19.8482 19 23 15.8482 23 12C23 8.15178 19.8482 5 16 5ZM32 5C28.1518 5 25 8.15178 25 12C25 15.8482 28.1518 19 32 19C35.8482 19 39 15.8482 39 12C39 8.15178 35.8482 5 32 5ZM16 8C18.2269 8 20 9.77309 20 12C20 14.2269 18.2269 16 16 16C13.7731 16 12 14.2269 12 12C12 9.77309 13.7731 8 16 8ZM32 8C34.2269 8 36 9.77309 36 12C36 14.2269 34.2269 16 32 16C29.7731 16 28 14.2269 28 12C28 9.77309 29.7731 8 32 8ZM9.5 21C7.57 21 6 22.57 6 24.5V34C6 39.514 10.486 44 16 44C18.542 44 20.859 43.0397 22.625 41.4707C21.989 40.6737 21.4522 39.7946 21.0332 38.8516C19.7592 40.1736 17.976 41 16 41C12.14 41 9 37.86 9 34V24.5C9 24.224 9.224 24 9.5 24H20.0254C20.1284 22.867 20.5728 21.831 21.2598 21H9.5ZM25.5 21C23.585 21 22 22.585 22 24.5V34C22 39.5048 26.4952 44 32 44C37.5048 44 42 39.5048 42 34V24.5C42 22.585 40.415 21 38.5 21H25.5ZM25.5 24H38.5C38.795 24 39 24.205 39 24.5V34C39 37.8832 35.8832 41 32 41C28.1168 41 25 37.8832 25 34V24.5C25 24.205 25.205 24 25.5 24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialContext);
export default __webpack_public_path__ + "static/media/social-context.cdaa979beb1b8e1f204a44a1af6d1120.svg";
export { ForwardRef as ReactComponent };